import React from 'react';
import MedicationLandingPage from '../components/MedicationLandingPage';

const data = {
  slug: 'naloxone',
  etsyUrl: 'https://www.etsy.com/shop/MyGuardPod?ref=seller-platform-mcnav&section_id=53896058',
  en: {
    title: 'NaloxPod Protective Carrying Case',
    subtitle: 'Purpose-built carrying case format designed to fit naloxone kit containers and supplies.',
    aboutTitle: 'About naloxone',
    aboutText: 'Naloxone is an opioid antagonist medication used to reverse opioid overdoses. It is carried by first responders, harm-reduction workers and community members. Product information, indications, dosage and administration instructions are established by the medication manufacturer and by applicable public-health guidance.',
    whyTitle: 'Why a fitted carrying case',
    whyText: 'Naloxone kits are often carried in work bags, vehicle compartments or field gear. A fitted carrying case can help keep the container and supplies organized, visible and identified during everyday carry.',
    whyPoints: [
      'Format-specific organization',
      'Highly visible identification',
      'Fitted layout for the specific listed medication format',
      'Added physical barrier during everyday carry',
      'Quick-opening carrying-case design',
      'Made to order in Qu\u00e9bec, Canada',
      'Medication and medical supplies not included',
    ],
    howTitle: 'What the NaloxPod is',
    howText: 'The NaloxPod is a protective carrying case format designed to contain, organize, identify and transport a compatible naloxone kit container and supplies. It does not administer, dose, monitor, preserve or modify the medication.',
    ctaTitle: 'Get your NaloxPod',
  },
  fr: {
    title: '\u00c9tui protecteur NaloxPod',
    subtitle: 'Format d\u2019\u00e9tui de transport con\u00e7u pour accueillir un contenant de kit de naloxone et son mat\u00e9riel.',
    aboutTitle: '\u00c0 propos de la naloxone',
    aboutText: 'La naloxone est un antagoniste des opio\u00efdes utilis\u00e9 pour renverser les surdoses d\u2019opio\u00efdes. Elle est transport\u00e9e par les premiers r\u00e9pondants, les travailleurs en r\u00e9duction des m\u00e9faits et des membres de la communaut\u00e9. Les renseignements sur le produit, les indications, la posologie et les instructions d\u2019administration sont \u00e9tablis par le fabricant du m\u00e9dicament et par les recommandations de sant\u00e9 publique applicables.',
    whyTitle: 'Pourquoi un \u00e9tui ajust\u00e9',
    whyText: 'Les kits de naloxone sont souvent transport\u00e9s dans des sacs de travail, des compartiments de v\u00e9hicule ou de l\u2019\u00e9quipement de terrain. Un \u00e9tui ajust\u00e9 peut aider \u00e0 garder le contenant et le mat\u00e9riel organis\u00e9s, visibles et identifi\u00e9s pendant le transport quotidien.',
    whyPoints: [
      'Organisation adapt\u00e9e au format',
      'Identification tr\u00e8s visible',
      'Am\u00e9nagement ajust\u00e9 au format de m\u00e9dicament indiqu\u00e9',
      'Barri\u00e8re physique ajout\u00e9e pendant le transport quotidien',
      'Ouverture rapide de l\u2019\u00e9tui',
      'Fabriqu\u00e9 sur commande au Qu\u00e9bec, Canada',
      'M\u00e9dicament et mat\u00e9riel m\u00e9dical non inclus',
    ],
    howTitle: 'Qu\u2019est-ce que le NaloxPod',
    howText: 'Le NaloxPod est un format d\u2019\u00e9tui de transport protecteur con\u00e7u pour contenir, organiser, identifier et transporter un contenant compatible de kit de naloxone et son mat\u00e9riel. Il n\u2019administre, ne dose, ne surveille, ne conserve et ne modifie aucun m\u00e9dicament.',
    ctaTitle: 'Obtenez votre NaloxPod',
  },
};

const NaloxoneCasePage = () => <MedicationLandingPage medication={data} />;
export default NaloxoneCasePage;
